export const createStyles = (theme: any) => {
  const { palette } = theme;
  const isDark = palette?.mode === 'dark';

  return {
    sidebarWrapper: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start',
      overflow: 'hidden',
    },
    sidebarNavigation: {
      px: { xs: '16px', md: '12px' },
      pt: { xs: '16px', md: '12px' },
      marginLeft: '-8px',
    },
    sidebarHeader: {
      display: 'flex',
      flexDirection: 'column',
      px: '12px',
      mb: '16px',
      minHeight: 0,
    },
    assignmentTitle: {
      display: '-webkit-box',
      my: '16px',
      overflow: 'hidden',
      overflowWrap: 'anywhere',
      textOverflow: 'ellipsis',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      fontSize: '20px',
      fontWeight: 500,
    },
    newExtension: {
      height: '42px',
      fontWeight: '500',
    },
    sidebarContent: {
      flex: 1,
      overflowY: 'auto',
      listStyle: 'none',
      m: 0,
      px: '12px',
      pb: '12px',
    },
    extensions: {
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      border: `1px solid ${isDark ? '#F8F7F929' : '#231F2929'}`,
      borderRadius: '8px',
    },
    extensionItem: {
      alignItems: 'center',
      display: 'flex',
      minHeight: '64px',
      px: '12px',
      '&:hover': {
        backgroundColor: 'action.hover',
      },
      borderBottom: `1px solid ${isDark ? '#F8F7F929' : '#231F2929'}`,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    extensionIcon: {
      flexShrink: 0,
      mr: '12px',
    },
    extensionTitle: {
      flex: 1,
      fontSize: '16px',
      fontWeight: 500,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    menuIcon: {
      flexShrink: 0,
      ml: '4px',
      color: isDark ? '#FFFFFF8F' : '#231F298F',
    },
    menuButtonWrapper: {
      display: 'inline-flex',
    },
    extensionMenu: {
      '& .MuiPaper-root, & .MuiMenu-paper, & .MuiPopover-paper, & .MuiMenu-list, & .MuiList-root':
        {
          backgroundColor: isDark ? '#363636 !important' : undefined,
          color: isDark ? '#ffffff' : undefined,
        },
    },
    visibilityIcon: {
      flexShrink: 0,
      ml: '4px',
      color: isDark ? '#FFFFFF' : '#000000DE',
    },
  };
};
